var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetsChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.881 71.242 h 1.68 C 82.088 71.242 89 64.329 89 55.802 V 19.436 c 0 -8.527 -6.912 -15.439 -15.439 -15.439 H 16.439 C 7.912 3.996 1 10.909 1 19.436 v 36.367 c 0 8.527 6.912 15.439 15.439 15.439 v 14.762 l 14.306 -14.762 h 12.06",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(97,146,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.56 77.562 h -6.035 c -3.491 0 -6.321 -2.83 -6.321 -6.321 v 0 c 0 -3.491 2.83 -6.321 6.321 -6.321 h 6.035 c 3.491 0 6.321 2.83 6.321 6.321 v 0 C 71.881 74.732 69.051 77.562 65.56 77.562 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(55,69,140)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.439 87.004 c -0.126 0 -0.254 -0.023 -0.375 -0.073 c -0.377 -0.152 -0.625 -0.52 -0.625 -0.927 V 72.211 C 6.839 71.692 0 64.531 0 55.803 V 19.436 C 0 10.371 7.375 2.997 16.439 2.997 h 57.121 C 82.625 2.997 90 10.371 90 19.436 v 36.367 c 0 9.064 -7.375 16.438 -16.439 16.438 h -1.68 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 h 1.68 C 81.522 70.241 88 63.764 88 55.803 V 19.436 c 0 -7.961 -6.478 -14.439 -14.439 -14.439 H 16.439 C 8.478 4.997 2 11.474 2 19.436 v 36.367 c 0 7.961 6.478 14.438 14.439 14.438 c 0.552 0 1 0.447 1 1 v 12.294 l 12.587 -12.99 c 0.188 -0.194 0.448 -0.304 0.718 -0.304 h 12.061 c 0.552 0 1 0.447 1 1 s -0.448 1 -1 1 H 31.168 L 17.158 86.7 C 16.965 86.898 16.705 87.004 16.439 87.004 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.561 78.563 h -6.036 c -4.036 0 -7.32 -3.284 -7.32 -7.321 c 0 -4.036 3.284 -7.32 7.32 -7.32 h 6.036 c 4.036 0 7.32 3.284 7.32 7.32 C 72.881 75.278 69.597 78.563 65.561 78.563 z M 59.524 65.921 c -2.934 0 -5.32 2.387 -5.32 5.32 c 0 2.935 2.387 5.321 5.32 5.321 h 6.036 c 2.934 0 5.32 -2.387 5.32 -5.321 c 0 -2.934 -2.387 -5.32 -5.32 -5.32 H 59.524 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 52.286 c -5.006 0 -10.013 -2.021 -14.984 -6.065 c -0.429 -0.349 -0.493 -0.979 -0.145 -1.407 c 0.35 -0.428 0.979 -0.493 1.407 -0.145 c 9.234 7.512 18.209 7.512 27.444 0 c 0.43 -0.349 1.06 -0.283 1.406 0.145 c 0.349 0.428 0.284 1.058 -0.145 1.407 C 55.013 50.265 50.006 52.286 45 52.286 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.431 33.046 c -0.552 0 -1 -0.448 -1 -1 v -5.194 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 5.194 C 36.431 32.598 35.983 33.046 35.431 33.046 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54.568 33.046 c -0.553 0 -1 -0.448 -1 -1 v -5.194 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 5.194 C 55.568 32.598 55.121 33.046 54.568 33.046 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsChats);
export default __webpack_public_path__ + "static/media/lets_chats.bd29df5dfd47fd4e5a67367a156614a3.svg";
export { ForwardRef as ReactComponent };